import React from "react";
import CareerNav from "../../components/Navbar/CarrerNav";
import Footer from "../../components/Home/footer/Footer";
import { Helmet } from "react-helmet";
import {
  commitment,
  diversity,
  diversity2,
  equity,
  inclusion,
} from "../../Assets";

const Diversity = () => {
  return (
    <>
      <Helmet>
        <title> Diversity & Inclusion at Avijobs: Empowering Every Voice</title>
        <meta
          name='discription'
          content='At Avijobs, diversity is our strength. We are committed to an inclusive workplace where different perspectives drive innovation and positive change.
'
        />
      </Helmet>
      <div className='App'>
        <CareerNav />
        <Header />
        <LearnMore />
        <Footer />
      </div>
    </>
  );
};
const Header = () => (
  <header
    className='hero bg-white p-12'
    style={{ fontFamily: "Gilroy-SemiBold" }}
  >
    <div class='flex items-center justify-between p-12 md:flex-row'>
      <div className='w-50 flex h-full flex-col p-12'>
        <div className='flex-grow'>
          <h2 className='text-4xl' style={{ fontFamily: "Gilroy-SemiBold" }}>
            Diversity, Equity, and Inclusion
          </h2>
          <span className='text-lg'>
            We are committed to fostering a workplace where diversity, equity,
            and inclusion are not just values, but integral aspects of our
            company culture. We believe that a diverse team, enriched by
            different backgrounds, experiences, and perspectives, drives
            innovation and creativity.
          </span>
        </div>
      </div>
      <div className='w-50 ml-20 p-4'>
        <img
          src={diversity}
          alt='diversity'
          style={{ width: "100%", height: 300 }}
          className='rounded-lg'
        />
      </div>
    </div>
  </header>
);

const LearnMore = () => {
  const learnMoreData = [
    {
      image: diversity2,
      alt: "Diversity",
      title: "Diversity",
      text: "We embrace the unique qualities that each employee brings to the table. Our team is made up of individuals from various walks of life, including different ethnicities, genders, ages, abilities, and cultures. This diversity fuels our growth and strengthens our ability to serve a diverse global community.",
    },
    {
      image: equity,
      alt: "Equity",
      title: "Equity",
      text: "Equity means ensuring that all employees have access to the same opportunities for growth, development, and success. We are dedicated to providing fair treatment, resources, and support, tailored to meet the unique needs of each team member. Our commitment to equity ensures that everyone can thrive and contribute to their fullest potential.",
    },
    {
      image: inclusion,
      alt: "Inclusion",
      title: "Inclusion",
      text: "Inclusion is about creating a welcoming environment where everyone feels valued, respected, and able to be their authentic selves. We work hard to cultivate a culture of belonging, where all voices are heard, and everyone feels empowered to share their ideas and perspectives. We believe that when people feel included, they are more engaged, innovative, and productive.",
    },
    {
      image: commitment,
      alt: "Commitment",
      title: "Our Commitment",
      text: "Our commitment to diversity, equity, and inclusion is reflected in our hiring practices, employee development programs, and workplace policies. We continuously strive to improve our DEI initiatives, listening to our employees and evolving to meet the needs of our dynamic team. We are not just building a company; we are building a community where everyone can succeed together.",
    },
  ];

  const LearnMoreItem = ({ item }) => {
    const { image, alt, title, text } = item;
    return (
      <div className='learn-more-item'>
        <img src={image} alt={alt} className='learn-more-img' loading='lazy' />
        <h6 className='learn-more-title'>{title}</h6>
        <p className='learn-more-text'>{text}</p>
      </div>
    );
  };

  return (
    <section className='bg-whites border-b-[1px]'>
      <div className='explore container'>
        <h3 className='font-[Gilroy-SemiBold] text-[#636363]'>
          We Think & Learn More Than We Work
        </h3>
        <div className='learn-more-content'>
          {learnMoreData.map((item, index) => (
            <LearnMoreItem key={index} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Diversity;
